import { ACCESS_MODE } from 'src/interfaces/workspacesReduxShapes';
import { TFieldOption, TRadioFields } from 'src/interfaces/WorkspacesTypes';

export enum WORKSPACE_FIELDS {
  NAME = 'name',
  EMAIL = 'email',
  ACCESS = 'access'
}

export enum WORKSPACE_ACTIONS {
  DELETE = 'delete',
  CREATE_WORKSPACE = 'create_workspace',
  EDIT_WORKSPACE = 'edit_workspace',
  GRANT_ACCESS = 'grant_access',
  EDIT_ACCESS = 'edit_access'
}

export const workspaceNameFields: TFieldOption[] = [
  {
    name: WORKSPACE_FIELDS.NAME,
    placeholder: 'Workspace Name',
    label: 'Name:'
  }
];

export const accessFields = (action: WORKSPACE_ACTIONS, inputValue: Record<string, string>): TFieldOption[] => [
  {
    name: WORKSPACE_FIELDS.EMAIL,
    placeholder: 'Email',
    label: 'Email:',
    disabled: action === WORKSPACE_ACTIONS.EDIT_ACCESS,
    inputValue: action === WORKSPACE_ACTIONS.EDIT_ACCESS ? inputValue?.[WORKSPACE_FIELDS.EMAIL] || '' : undefined
  }
];

export const accessRadio: TRadioFields = {
  name: WORKSPACE_FIELDS.ACCESS,
  options: [
    { label: 'Can Edit', value: ACCESS_MODE.EDITOR },
    { label: 'Can View', value: ACCESS_MODE.VIEWER }
  ]
};

export const workspaceNameCreateInitialValues = {
  [WORKSPACE_FIELDS.NAME]: ''
};

export const workspaceNameEditInitialValues = (name: string): { name: string } => ({
  [WORKSPACE_FIELDS.NAME]: name
});

const grantAccessInitialValues = {
  [WORKSPACE_FIELDS.EMAIL]: '',
  [WORKSPACE_FIELDS.ACCESS]: ''
};

const editAccessInitialValues = {
  [WORKSPACE_FIELDS.ACCESS]: ''
};

export const accessInitialValues = {
  [WORKSPACE_ACTIONS.GRANT_ACCESS]: grantAccessInitialValues,
  [WORKSPACE_ACTIONS.EDIT_ACCESS]: editAccessInitialValues
};

export const SAVED_LAST_WS_KEY = 'savedLastWorkspace';
